import { useEffect, useState } from "react";
import Report from "../components/personalPerformance/Report";
import "../components/personalPerformance/personal-performance.scss";
import StatisticsList from "../components/personalPerformance/StatisticsList";
import ServiceTime from "../components/personalPerformance/ServiceTime";
import useAxios from "../services/useAxios";
import PersonnelReport from "../components/personalPerformance/PersonnelReport";
import Loader from "../utils/Loader";
export default function PersonalPerformance() {
  const [reportData, setReportData] = useState({ from: "", to: "" });
  const [reportDataError, setReportDataError] = useState({ from: "", to: "" });
  const [personnelReport, setPersonnelReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statisticData, setStatisticData] = useState({
    countOperation: 0,
    activePersonnel: 0,
    assessedPersonnel: 0,
    averageAttendance: 0,
    Operation: 0,
    UsefulDailyOutput: 0,
  });
  const { loadingStatistics, execute: statistics } = useAxios(
    "test/statistical_information"
  );
  const { loadingPersonnelReport, execute: personnelReportApi } = useAxios(
    "test/statistical_information2"
  );
  const reportDataHandler = (object) => {
    setReportData((prev) => {
      return { ...prev, ...object };
    });
  };
  const reportDataErrorHandler = (object) => {
    setReportDataError((prev) => {
      return { ...prev, ...object };
    });
  };
  const reportValidation = () => {
    let valid = true;
    if (reportData.from == "") {
      reportDataErrorHandler({ from: "انتخاب کنید." });
      valid = false;
    } else {
      reportDataErrorHandler({ from: "" });
    }
    if (reportData.from == "") {
      reportDataErrorHandler({ to: "انتخاب کنید." });
      valid = false;
    } else {
      reportDataErrorHandler({ to: "" });
    }
    return valid;
  };
  const filter = () => {
    if (reportValidation)
      statisticFunc(reportData?.from?.unix, reportData?.to?.unix);
  };
  const statisticFunc = (from = "", to = "") => {
    let temp = {};
    if (from != "" && to != "") temp = { to_date: to, from_date: from };
    statistics(temp).then((result) => {
      setStatisticData(result);
      setLoading(false);
    });
  };
  const personnelReportFunc = () => {
    personnelReportApi().then((result) => {
      setPersonnelReport(result.all);
    });
  };
  useEffect(() => {
    setLoading(true);
    statisticFunc();
    personnelReportFunc();
  }, []);
  return loading ? (
    <Loader />
  ) : (
    <div className="personale-performance p-3">
      <div className="d-flex align-items-center first-row">
        {" "}
        <h5 className="fw-bolder fs-5 me-auto"> داشبورد مدیریت عملکرد پرسنل</h5>
        <div className="ms-auto me-3 report">
          <Report
            reportData={reportData}
            reportDataHandler={reportDataHandler}
            reportDataError={reportDataError}
            filter={filter}
          />
        </div>
      </div>
      <div className="second-row">
        <StatisticsList data={statisticData} />
      </div>
      <div className="third-row" style={{}}>
        <ServiceTime data={statisticData} />
      </div>
      <div className="fourth-row ">
        <PersonnelReport data={personnelReport} />
      </div>
    </div>
  );
}
